import {gql} from '@apollo/client';

export const RemoveDeal = gql`
  mutation RemoveDeal($id: ID!) {
    removeDeal(id: $id)
  }
`;
